// extracted by mini-css-extract-plugin
export var chevron = "_i7-2";
export var dropdownItems = "_i7-0";
export var item = "_i7-1";